import parse from 'html-react-parser';
import { Box } from '@chakra-ui/react';

type PrivacyPolicyProps = {
  policy?: string;
};

const PrivacyPolicy = ({ policy }: PrivacyPolicyProps) => {
  if (!policy || policy.length === 0) return null;

  return (
    <Box
      mb={6}
      fontSize={14}
      css={{
        a: { color: 'var(--chakra-colors-primaryThemeColour-400)' },
        'a:hover': {
          textDecoration: 'underline',
        },
      }}
    >
      {parse(policy)}
    </Box>
  );
};

export default PrivacyPolicy;
